module.exports = __webpack_public_path__ + "assets/img/yellow-copy.a578c429.svg";